import {
    FormField,
    Header,
    Title,
    Wrapper,
    WrapperEmployee,
} from "features/allocations/components/grid/employee/styles/SearchEmployee.styles";
import React, { useCallback, useContext, useEffect, useState } from "react";

import CustomGroupContext from "features/allocations/contexts/CustomGroupContext";
import DrawerContext from "shared/contexts/DrawerContext";
import EmployeeDrawerNew from "features/allocations/components/grid/employee/EmployeeDrawerNew";
import IconTextInput from "shared/components/inputs/icon-input/IconTextInput";
import Magnifier from "shared/components/utils/icons/Magnifier";
import Profile from "shared/components/data-display/card/Profile";
import PropTypes from "prop-types";
import Right from "shared/components/utils/icons/Right";
import Text from "shared/components/data-display/mui/Text";
import env from "react-dotenv";
import { useLocalStorage } from "shared/hooks/useLocalStorage";
import { useUser } from "shared/services/api/useUser";

const SearchEmployeeNew = (props) => {
    const { defaultValue } = props;
    const { getEmployeesForSearch } = useUser();
    const { setWithExpiry } = useLocalStorage();
    const { getWithExpiry } = useLocalStorage();
    const { get } = useLocalStorage();
    const { set } = useLocalStorage();
    const [employees, setEmployees] = useState([]);
    const [showHistory, setShowHistory] = useState(true);
    const [cache, setCache] = useState(null);
    const [drawerUserId, setDrawerUserId] = useState();
    const customGroupConsumer = useContext(CustomGroupContext);
    const { displaySearch, setDisplaySearch } = useContext(DrawerContext);

    const filterByName = useCallback((data, inputValue) => {
        const results = data.filter((object) => {
            return object.SearchText.includes(inputValue.toLowerCase());
        });
        setEmployees(results);
    }, []);

    const handleOnChange = useCallback(async function (inputValue) {
        if (inputValue && cache) {
            filterByName(cache, inputValue);
            setShowHistory(false);
        } else {
            setShowHistory(true);
        }
    }, [cache, filterByName]);

    useEffect(() => {
        if (defaultValue && cache) {
            handleOnChange(defaultValue);
        }
    }, [cache, defaultValue, handleOnChange]);

    useEffect(() => {
        async function getEmployees() {
            let list = await getWithExpiry("employees-search");
            if (list == null) {
                try {
                    const payload = await getEmployeesForSearch([{ name: "$name", value: "" }]);
                    setWithExpiry(
                        "employees-search",
                        payload,
                        env.BESTWORK_REACT_EMPLOYEEFORSEARCH_EXPIRYMIN
                    );
                    list = payload;
                } catch {
                    // Error silently
                }
            }
            setCache(list);
        }

        getEmployees();

    }, [getEmployeesForSearch, getWithExpiry, setWithExpiry]);

    const debounce = (func, delay) => {
        let debounceTimer;
        return (...args) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func(...args), delay);
        };
    };

    const optimisedHandleChange = debounce(handleOnChange, 500);

    useEffect(() => {
        const getHistory = () => {
            let data = get("employees-search-history");
            if (data) {
                setEmployees(data);
            }
            else {
                setEmployees([]);
            }
        };

        if (showHistory) getHistory();
    }, [showHistory, get]);

    const handleSelect = (employee) => {
        saveHistory(employee);
        setDrawerUserId(employee.Id);
        setDisplaySearch(false);
    };

    const saveHistory = (employee) => {
        // Get current history
        let currentData = get("employees-search-history") || [];
        //remove duplicates
        currentData = currentData.filter((data) => data.Id !== employee.Id);
        //save selected
        currentData.unshift(employee);
        set(
            "employees-search-history",
            currentData.slice(
                0,
                env.BESTWORK_REACT_EMPLOYEEFORSEARCH_HISTORYLIMIT
            )
        );
    };

    useEffect(() => {
        return () => {
            setDrawerUserId(null);
        };
    }, []);

    return (
        <>
            {displaySearch && (
                <>
                    <Header>
                        <Title>
                            <Text variant="xxlargeBold">Search Employees</Text>
                        </Title>
                        <FormField>
                            <IconTextInput
                                label="Employee Name"
                                defaultValue={defaultValue}
                                type="text"
                                icon={<Magnifier />}
                                onChange={optimisedHandleChange}
                            />
                        </FormField>

                        <Text variant="xsmallLight">
                            {showHistory && "Recently Viewed"}{" "}
                            {!showHistory &&
                                !!employees.length &&
                                "Search Results (" + employees.length + ")"}
                            {!showHistory && !employees.length && "No Results"}
                        </Text>
                    </Header>
                    <Wrapper>
                        {employees?.map((employee) => (
                                <WrapperEmployee
                                    key={employee.Id}
                                    onClick={() => handleSelect(employee)}
                                >
                                    <Profile
                                        name={employee.FullName}
                                        title={employee.Title}
                                        location={employee.Office}
                                        image={
                                            env.BESTWORK_REACT_ASSET_DOMAIN +
                                            "/" +
                                            employee.PhotoURL
                                        }
                                        freelance={false}
                                    />
                                    <Right circle={false} />
                                </WrapperEmployee>
                            ))}
                    </Wrapper>
                </>
            )}
            {drawerUserId && !displaySearch && (
                <CustomGroupContext.Provider value={customGroupConsumer}>
                    <EmployeeDrawerNew userId={drawerUserId} />
                </CustomGroupContext.Provider>
            )}
        </>
    );
};

SearchEmployeeNew.propTypes = {
    defaultValue: PropTypes.string,
};

export default SearchEmployeeNew;
